// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingSpinner_loading-spinner__fcows","spinner":"LoadingSpinner_spinner__HCLI2"};